module.exports = __webpack_public_path__ + "img/zongbuquanpan.6d0db6be.png";